import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Form, notification } from "antd";
import { LookupRequest } from "../../../models/lookup-request";
import { buildAgencyRequest } from "../../../state/connect-api";
import { useResetPasswordMutation, useValidateRecoverUserMutation } from "../../../state/agencyApi";

const useRecoverPassword = () => {
  const [recoverPasswordForm] = Form.useForm();
  const [resetPasswordForm] = Form.useForm();
  const [isValidated, setIsValidated] = useState<boolean>(false);
  const [recoveryQuestion, setRecoveryQuestion] = useState<string>("");
  const navigate = useNavigate();
  const [recoverPassword, { isLoading: recoverPasswordLoading }] = useValidateRecoverUserMutation();
  const [resetPassword, { isLoading: resetPasswordLoading }] = useResetPasswordMutation();

  const handleRecoverClick = async () => {
    const formValues = await recoverPasswordForm.validateFields();
    const lookupRequest: LookupRequest = buildAgencyRequest(formValues.AGENCY_ID, formValues.REFERENCE_CODE);
    const results = await recoverPassword(lookupRequest).unwrap();
    if (results.ERROR[0].ERROR) {
      notification.error({ message: results.ERROR[0].ERROR });
    } else {
      resetPasswordForm.setFieldsValue({ AGENCY_ID: formValues.AGENCY_ID, REFERENCE_CODE: formValues.REFERENCE_CODE });
      setRecoveryQuestion(results.MAIN[0].QUESTION);
      setIsValidated(true);
    }
  };

  const handleResetClick = async () => {
    const formValues = await resetPasswordForm.validateFields();
    const lookupRequest: LookupRequest = buildAgencyRequest(formValues.AGENCY_ID, formValues.REFERENCE_CODE, formValues.ANSWER, formValues.PASSWORD, formValues.CONFPASSWORD, String(false));
    const results = await resetPassword(lookupRequest).unwrap();
    if (results.ERROR[0].ERROR) {
      notification.error({ message: results.ERROR[0].ERROR });
    } else {
      notification.success({ message: "Password reset successfully" });
      navigate("/login");
    }
  };

  const handleOnCancelClick = () => navigate("/login");

  return {
    recoverPasswordForm,
    resetPasswordForm,
    recoverPasswordLoading,
    resetPasswordLoading,
    recoveryQuestion,
    isValidated,
    handleRecoverClick,
    handleResetClick,
    handleOnCancelClick
  };
};

export default useRecoverPassword;
